import { render, staticRenderFns } from "./Industry4.vue?vue&type=template&id=73fce9a3&"
import script from "./Industry4.vue?vue&type=script&lang=js&"
export * from "./Industry4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports